export default __webpack_public_path__ + "static/media/carddroping.f7caae0e.mp3";